import styled from "@emotion/styled";
import { Chip } from "@schaeffler-commerce/design-system";
import type { CMSChipLinkProps } from "~/features/cms/components/cmsChip/CMSChipLink";
import { Avatar } from "@schaeffler-commerce/design-system";
import { resolveUrl } from "~/utils/url/urlResolver";

const CMSChipLinkStandard = ({ chip, iconUrl, className, variant = "assist" }: CMSChipLinkProps) => {
  return (
    <StyledChip
      className={className}
      component={"a"}
      href={resolveUrl(chip.navigationEntry.linkComponent.url)}
      variant={variant}
      label={chip.title || chip.navigationEntry.linkComponent.name}
      {...(iconUrl && {
        avatar: <Avatar src={iconUrl} sx={{ borderRadius: 0 }} />,
      })}
    />
  );
};

const StyledChip = styled(Chip)({
  cursor: "pointer",
});

export default CMSChipLinkStandard;
